import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';
import logo from '../assets/logo.png';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const handleLinkClick = () => {
    setIsOpen(false);
    setServicesOpen(false);
  };

  
  return (
    <header className="header">
      <div className="logo-container">
        <img src={logo} alt="Logo" className="logo" />
      </div>

      <nav className={`nav ${isOpen ? 'open' : ''}`}>
        <ul>
          <li><Link to="/" onClick={handleLinkClick}>Home</Link></li>
          <li><Link to="/aboutus" onClick={handleLinkClick}>About Us</Link></li>
          
          <li
            className="services-dropdown"
            onClick={() => setServicesOpen(!servicesOpen)}
            style={{ userSelect: 'none', cursor: 'pointer' }}
          >
            <span className="dropdown-toggle">
              Services <span style={{ marginLeft: 6 }}>{servicesOpen ? '▲' : '▼'}</span>
            </span>
            {servicesOpen && (
              <ul className="services-dropdown-menu" onClick={e => e.stopPropagation()}>
                <li><Link to="/servicepg" onClick={handleLinkClick}>Website Design</Link></li>
                <li><Link to="/manpowerpg" onClick={handleLinkClick}>Manpower Outsourcing</Link></li>
                <li><Link to="/gstpg" onClick={handleLinkClick}>Gst Registration</Link></li>
              </ul>
            )}
          </li>

          <li><Link to="/contactpg" onClick={handleLinkClick}>Contact Us</Link></li>
        </ul>
      </nav>

      <button
        className={`menu-toggle ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </header>
  );
};

export default Header;
